import React, { useState, useEffect } from 'react';
import styles from './styles.module.scss';
// import DashBoardCard from "../../../../general/card";
import { Content } from 'antd/es/layout/layout';
import SkillCard from '../../../general/card/card-utils/card-detail/core-skills';
import RightPanelAccordion from '../../../general/card/card-full';
const RightPanel: React.FC = (): JSX.Element => {
  return (
    <>
      <RightPanelAccordion />
    </>
  );
};

export default RightPanel;
